import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
} from "chart.js";
import { Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

const CollectionReceivedLineChart = ({ data = [] }) => {
  /* ================= RESPONSIVE ================= */
  const isMobile = window.innerWidth < 640;

  // ✅ HARD GUARD
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div style={{ height: 260, textAlign: "center" }}>
        No data
      </div>
    );
  }

  /* ================= DATA ================= */
  const labels = data.map(d => d.month);
  const values = data.map(d => {
    const v = Number(d.amount);
    return isNaN(v) ? 0 : v;
  });

  /* ================= SCROLL WIDTH ================= */
  const pointWidth = isMobile ? 90 : 100; // per month spacing
  const chartWidth = isMobile
    ? Math.max(labels.length * pointWidth, window.innerWidth)
    : "100%";

  /* ================= CHART DATA ================= */
  const chartData = {
    labels,
    datasets: [
      {
        label: "Collection Received",
        data: values,
        borderColor: "#d32f2f",
        backgroundColor: "rgba(211,47,47,0.15)",
        fill: true,
        tension: 0.4,
        pointRadius: 3,
        pointHoverRadius: 6,
        datalabels: {
          display: true,
          align: "top",
          anchor: "end",
          color: "#2e7d32",
          font: {
            weight: "bold",
            size: 10
          },
          formatter: value => `${value.toFixed(2)} L`
        }
      }
    ]
  };

  /* ================= OPTIONS ================= */
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    plugins: {
      legend: {
        display: true,
        position: "top",
        align: "end"
      },
      tooltip: {
        callbacks: {
          label: ctx => `${ctx.raw.toFixed(2)} L`
        }
      },
      datalabels: {
        clamp: true,
        clip: false
      }
    },
    scales: {
      x: {
        ticks: {
          autoSkip: false,
          maxRotation: isMobile ? 0 : 45,
          minRotation: isMobile ? 0 : 45
        }
      },
      y: {
        title: { display: true, text: "Collection Received" },
        beginAtZero: true,
        grace: "10%",
        ticks: {
          callback: value => `${value.toFixed(0)} L`
        }
      }
    }
  };

  /* ================= RENDER ================= */
  return (
    <div style={{ position: "relative" }}>
      {/* SCROLL HINT */}
      {isMobile && (
        <div
          style={{
            fontSize: 11,
            color: "#6b6b8a",
            textAlign: "right",
            marginBottom: 4
          }}
        >
          ← Swipe →
        </div>
      )}

      {/* SCROLLABLE CHART */}
      <div
        style={{
          height: 260,
          position: "relative",
          overflowX: isMobile ? "auto" : "hidden",
          overflowY: "hidden",
          WebkitOverflowScrolling: "touch"
        }}
      >
        <div style={{ width: chartWidth, height: "100%" }}>
          <Line data={chartData} options={options} />
        </div>

        {/* RIGHT FADE INDICATOR */}
        {/* {isMobile && (
          <div
            style={{
              pointerEvents: "none",
              position: "absolute",
              top: 0,
              right: 0,
              width: 36,
              height: "100%",
              background:
                "linear-gradient(to left, rgba(255,255,255,0.95), rgba(255,255,255,0))"
            }}
          />
        )} */}
      </div>
    </div>
  );
};

export default CollectionReceivedLineChart;
